import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import Cookies from "js-cookie";

export const useTracking = async () => {
    const { listen } = useHistory();
    useEffect(() => {
        return listen(location => {
            sendRouteChangeToGoogleAnalytics(location.pathname);
        });
    }, [listen]);
};

export const populateAndPushDataLayerForGoogleAnalytics = () => {
    const userTrackingId = Cookies.get("user_tracking_id");
    const userCookiesConsent = Cookies.get("user_consented_to_use_cookies");

    if (typeof userTrackingId !== "undefined") {
        window.dataLayer.push({
            ga_user_id: `T${userTrackingId}`,
            user_type: "tutor",
        });
    }

    if (typeof userCookiesConsent !== "undefined") {
        window.dataLayer.push({
            "Marketing Cookie Opt In": userCookiesConsent,
        });
    }

    if (window.ga) {
        window.ga("set", "dimension1", "Tutor");
        window.ga("set", "dimension3", userTrackingId);
    }
};

export const sendRouteChangeToGoogleAnalytics = pathname => {
    if (window.ga) {
        window.ga("send", "pageview", pathname);
    }
};
